import {
  DeleteIcon,
  DeleteIconRed,
  DownloadUploadedFile,
  EyeIcon,
  ViewDetailsIcon,
} from "icons";
import styles from "./styles.module.scss";
import { UseApiCallV2, UseLazyApiCallV2 } from "hooks";
import { useParams } from "react-router-dom";
import { message, Spin } from "antd";
import { ConditionalRenderer } from "components";
import { dummyPdf } from "utils/constants";
import { useLanguageTranslator } from "hooks/use-language-translator";
import moment from "moment";
import { useState } from "react";
import { ExtractedDataModal } from "pages/cases-detail/components/extractedDataModal";
import { clientMasterData, formFields } from "pages/cases-detail/constants";
import { useRecoilState } from "recoil";
import { caseStatus } from "store/atom";

export const UploadedFiles = ({
  uploadedFiles,
  isLoading,
  documentType,
  refetchUploaded,
  refetchLegalDocs,
  refetchDetail,
  dropdownsListObj,
  refetchCount,
}) => {
  const { translator } = useLanguageTranslator();
  const [queries, setQueries] = useState([]);
  const [openExtractedDetail, setOpenExtractedDetails] = useState(false);
  const [selectedFile, setselectedFile] = useState(null);
  const [caseStatusOpenOrClosed, setCaseStatusOpenOrClosed] =
    useRecoilState(caseStatus);

  const uploadFileTrans = translator("caseDetail.uploadFiles");
  const { caseId } = useParams();
  const [
    getFileUrl,
    { data: fileUrlData, isLoading: fileUrlLoading, error: fileUrlError },
  ] = UseLazyApiCallV2({
    url: "/download_pdf",
    method: "POST",
  });
  const [
    deleteUploadedFile,
    {
      data: deleteUploadedFileData,
      isLoading: deleteUploadedFileLoading,
      error: deleteUploadedFileError,
    },
  ] = UseLazyApiCallV2({
    url: "/delete_file",
    method: "POST",
  });

  async function downloadOrView({ item }) {
    const params = {
      case_id: caseId,
      documentType,
      fileName: item?.fileName,
    };

    try {
      const res = await getFileUrl({
        params,
      });
      if (res?.download_url) {
        window.open(res?.download_url);
      }
    } catch (error) {
      message.error(translator("somethingWentWrong"));
    }
  }
  const [
    getScannedDoc,
    {
      data: scannedData,
      isLoading: scannedDataLoading,
      error: scannedDataError,
    },
  ] = UseLazyApiCallV2({
    url: "/get_scanned_document",
    method: "POST",
  });
  function filterFieldsByApiDataWithChildAnswers(
    totalFields,
    apiData,
    dropdownsListObj = {},
  ) {
    if (!totalFields || !apiData) return [];

    const apiKeys = new Set(Object.keys(apiData));

    return totalFields
      .map((field) => {
        // Parent field: keep only sections that have childs present in apiData
        if (field.isParent && Array.isArray(field.sections)) {
          const filteredSections = field.sections
            .map((section) => {
              const filteredChilds = (section.childs || [])
                .filter(
                  (child) =>
                    apiKeys.has(child.key) &&
                    apiData[child.key] != null &&
                    apiData[child.key] !== "",
                ) // keep only childs present in API
                .map((child) => ({
                  // keep original child properties but add Answer/Query/checked/dropdownList
                  ...child,
                  Answer: apiData[child.key],
                  Query: child.key,
                  checked: true,
                  dropdownList: dropdownsListObj[child.key] || [],
                }));

              return filteredChilds.length > 0
                ? { ...section, childs: filteredChilds }
                : null;
            })
            .filter(Boolean);

          // Keep parent only if parent key exists in API OR it has at least one matching child
          if (apiKeys.has(field.key) || filteredSections.length > 0) {
            return {
              ...field,
              Answer: apiData[field.key],
              Query: field.key,
              checked: !!apiData[field.key],
              sections: filteredSections,
            };
          }

          return null; // drop parent completely if no relevant keys
        }

        // Non-parent standalone field: keep only if present in API
        if (
          apiKeys.has(field.key) &&
          apiData[field.key] != null &&
          apiData[field.key] !== ""
        ) {
          return {
            ...field,
            Answer: apiData[field.key],
            Query: field.key,
            checked: true,
            dropdownList: dropdownsListObj[field.key] || [],
          };
        }

        return null; // drop if not in API
      })
      .filter(Boolean);
  }

  async function viewFileDetail(data) {
    const { item: record } = data;
    setOpenExtractedDetails(true);
    setselectedFile({ ...record });
    const params = {
      case_id: record?.caseId,
      documentType: record?.documentType,
    };
    const res = await getScannedDoc({
      params,
    });
    const arrOfObjects = filterFieldsByApiDataWithChildAnswers(
      [...formFields, ...clientMasterData],
      res?.data,
    );
    // const checkup = restructureFields(arrOfObjects);

    if (!arrOfObjects) return;
    setQueries([...arrOfObjects]);
  }
  function restructureFields(data) {
    // Step 1: Make a lookup for quick access by key
    const lookup = {};
    data.forEach((item) => {
      lookup[item.key] = { ...item };
    });

    // Step 2: Build final array
    const result = [];

    data.forEach((item) => {
      // If it's a parent
      if (item.isParent && Array.isArray(item.childs)) {
        const newChilds = item.childs.map((child) => {
          // If child exists in original data (top level), merge its values
          if (lookup[child.key]) {
            return {
              ...child,
              ...lookup[child.key], // merge actual values (Answer, Query, checked, etc.)
              parentKey: item.key,
            };
          }
          return { ...child, parentKey: item.key };
        });

        result.push({ ...item, childs: newChilds });
      }
      // If it's not a child of some parent → keep it
      else if (!item.parentKey) {
        const isChildSomewhere = data.some(
          (parent) =>
            parent.isParent && parent.childs?.some((c) => c.key === item.key),
        );
        if (!isChildSomewhere) {
          result.push(item);
        }
      }
    });

    return result;
  }

  async function handleClickDelete({ item }) {
    //  fileName: item.fileName,
    //                     id: item?.id,

    const params = {
      case_id: caseId,
      documentType,
      fileName: item?.fileName,
      id: item?.id,
    };

    try {
      const res = await deleteUploadedFile({
        params,
      });
      if (res?.status === "Success") {
        message.success(res?.message);
        await refetchUploaded();
        await refetchLegalDocs();
        await refetchCount();
      }
    } catch (error) {
      message.error(translator("somethingWentWrong"));
    }
  }
  function handleCloseExtractedDetails() {
    setOpenExtractedDetails(false);
  }

  const icons = [
    {
      Icon: EyeIcon,
      key: "view",
      handleClick: viewFileDetail,
    },
    {
      Icon: DownloadUploadedFile,
      key: "download",
      handleClick: downloadOrView,
    },
    {
      Icon: DeleteIconRed,
      key: "delete",
      handleClick: handleClickDelete,
      bgColor: "#FFF3F3",
    },
  ];
  const dataEmpty = uploadedFiles?.status === "NOT_FOUND";
  return (
    <div className={styles.uploadedContainer} style={{ width: "100%" }}>
      <h3>{uploadFileTrans.uploadHeading}</h3>
      <Spin
        spinning={isLoading || fileUrlLoading || deleteUploadedFileLoading}
        style={{ width: "100%" }}
      >
        <ConditionalRenderer condition={!dataEmpty && !isLoading}>
          {uploadedFiles?.data?.map((item, index) => (
            <div
              className={styles.singleItem}
              key={`${item.file_name}-${index}`}
            >
              <div className={styles.name}>{item.fileName}</div>
              <div className={styles.uploadedBy}>
                {uploadFileTrans.uploadedBy}: <span>{item.uploadedByName}</span>
              </div>
              <div className={styles.uploadedAtAndIcons}>
                <div className={styles.uploadedAt}>
                  {uploadFileTrans.uploadedAt}:{" "}
                  <span>
                    {moment(item.uploadedAt, "YYYY-MM-DD HH:mm:ss").format(
                      "DD-MM-YYYY HH:mm:ss",
                    )}
                  </span>
                </div>
                <div className={styles.icons}>
                  {icons.map((childItem) => (
                    <div
                      className={`${styles.iconContainer} ${
                        caseStatusOpenOrClosed === "closed" &&
                        childItem?.key === "delete"
                          ? styles.disabledBtn
                          : ""
                      }`}
                      key={childItem.key}
                      style={{
                        backgroundColor: childItem.bgColor ? "#FFF3F3" : "",
                      }}
                      onClick={() =>
                        childItem.handleClick({
                          item,
                        })
                      }
                    >
                      {childItem?.Icon && (
                        <childItem.Icon height={12} width={13} />
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </ConditionalRenderer>
      </Spin>
      <ConditionalRenderer condition={dataEmpty && !isLoading}>
        <div className={styles.noDataFound}>
          <h2>{uploadFileTrans.noDataFound}</h2>
        </div>
      </ConditionalRenderer>
      <ExtractedDataModal
        handleCloseModal={handleCloseExtractedDetails}
        open={openExtractedDetail}
        queries={queries}
        setQueries={setQueries}
        documentType={selectedFile?.documentType}
        fileName={selectedFile?.fileName}
        refetchDetail={refetchDetail}
        allowUpdate={false}
      />
    </div>
  );
};
